var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3762 0.333008L0.366774 1.34496L5.99073 6.98299L0.333496 12.6655L1.33183 13.6663L7.00016 7.99495L12.6574 13.6663L13.6668 12.6544L8.00959 6.98299L13.6336 1.34496L12.6241 0.333008L7.00016 5.97104L1.3762 0.333008Z",
    fill: "#DC3545"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.c738d1c921316dcc05981f0e05ecb9c4.svg";
export { ForwardRef as ReactComponent };